import { DraggableLocation } from 'react-beautiful-dnd';
import { ExcelFields } from '../../types/api';
import { ActionKind, ExportAction } from './types';

export const reorderList = (list: ExcelFields[], startIndex: number, endIndex: number) => {
  const result = [...list];
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

const moveItem = (
  state: Record<string, ExcelFields[]>,
  source: DraggableLocation,
  destination: DraggableLocation
) => {
  const sourceClone = [...state[source.droppableId]];
  const destClone = [...state[destination.droppableId]];
  const [removed] = sourceClone.splice(source.index, 1);
  destClone.splice(destination.index, 0, removed);

  return {
    [source.droppableId]: sourceClone,
    [destination.droppableId]: destClone,
  };
};

export const dragReducer = (state: Record<string, ExcelFields[]>, action: ExportAction) => {
  const { type, destination, source } = action;
  switch (type) {
    case ActionKind.MOVE: {
      if (source!.droppableId === destination!.droppableId) {
        const reorderItems = reorderList(
          state[source!.droppableId],
          source!.index,
          destination!.index
        );
        return {
          ...state,
          [source!.droppableId]: reorderItems,
        };
      }
      const movedItems = moveItem(state, source!, destination!);
      return { ...movedItems };
    }
    case ActionKind.RIGHT: {
      return {
        items: [],
        selectedItems: [...state.selectedItems, ...state.items],
      };
    }
    case ActionKind.LEFT: {
      return {
        items: [...state.items, ...state.selectedItems],
        selectedItems: [],
      };
    }
    case ActionKind.TEMPLATE: {
      return {
        items: action.itemsArray!,
        selectedItems: action.selectedItemsArray!,
      };
    }
    default:
      return state;
  }
};

export const getItemDiff = (defaultFields: ExcelFields[], newFields: ExcelFields[]) =>
  defaultFields.filter(
    (defaultItem) => !newFields.some((newFieldsItem) => defaultItem.field === newFieldsItem.field)
  );
